import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, BOOKING_CONTINGENT_SUBSCRIPTION_TABS, InstallationsStore } from '@store';

@Component({
  selector: 'app-booking-contingent-subscriptions',
  templateUrl: './booking-contingent-subscriptions.component.html',
  styleUrls: ['./booking-contingent-subscriptions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingContingentSubscriptionsComponent implements OnInit {
  currentStep = BOOKING_CONTINGENT_SUBSCRIPTION_TABS.SELECT_DEVICE;

  @Input() invoiceNumber: string;

  constructor(public bookingStore: BookingStore, public installationsStore: InstallationsStore) {}

  ngOnInit(): void {
    this.bookingStore.resetUserSelection();
    this.bookingStore.loadInstallations();
    this.bookingStore.fetchSubscriptionsPlans();
    this.bookingStore.getContingentSubscriptions();
    this.bookingStore.getAllVitoguideSubscriptions();
    this.bookingStore.selectPlan(SubscriptionPlan.Pro);
  }

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }
}
